import { render } from "./TradeNumberInput.vue?vue&type=template&id=0b42b8be"
import script from "./TradeNumberInput.vue?vue&type=script&lang=js"
export * from "./TradeNumberInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__